import { createContext, useContext } from 'react';

import SnowPlowAnalytics, {
  sp,
} from 'components/Analytics/components/SnowPlowAnalytics';
import useFullStory, { fs } from 'components/Analytics/hooks/useFullStory';
import useLiveChat from 'components/Analytics/hooks/useLiveChat';
import useLytics from 'components/Analytics/hooks/useLytics';

import useDataEventListeners from './hooks/useDataEventListeners';
import useGoogleTagManager, { gtm } from './hooks/useGoogleTagManager';

export const AnalyticsContext = createContext({ gtm, fs, sp });

/** @type {import('./types').default} */
const Analytics = ({
  config = {},
  appData: {
    route,
    head,
    header,
    countryCode,
    userAgent,
    experiments,
    isDebugBear = false,
  } = {},
  children,
}) => {
  useGoogleTagManager(
    config.tagManager,
    head,
    countryCode,
    route,
    experiments?.ga4
  );
  useFullStory({
    route,
    experiment: experiments?.ga4,
    userId: header?.user?.id,
    contentRichSection: head?.data_layer?.find(
      ({ contentRichSection }) => contentRichSection
    )?.contentRichSection,
    contentType: head?.data_layer?.find(({ content_type }) => content_type)
      ?.content_type,
  });
  useLytics(head?.lytics_id);
  useDataEventListeners();
  useLiveChat({
    enabled: userAgent?.isDesktop && head?.hasLiveChatEnabled && !isDebugBear,
  });

  return (
    <AnalyticsContext.Provider value={{ gtm, fs, sp }}>
      <SnowPlowAnalytics
        experiments={experiments?.ga4}
        currentPageActiveExperimentIds={
          experiments?.currentPageActiveExperimentIds || []
        }
        countryCode={countryCode}
      />
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = () => {
  // It returns a list to be able to have in
  // a second position an object to send events
  // to all included trackers
  return [useContext(AnalyticsContext)];
};

export default Analytics;
